module.exports = __webpack_public_path__ + "media/images/emblems/GrandSaconnex-coat_of_arms-60ebe603466be44c4259116a296b5a09.svg";